module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step4_img.3f42855e.svg";